export class MediaQueryService {
    static match(query: string): boolean {
        return window.matchMedia(query).matches;
    }
}
